<template>
  <div class="loginTabs">
    <ul class="tablist">
      <li
        v-for="(item, index) in data"
        :key="index"
        :class="{ active: index === activeIndex }"
        @click="slideTo(index)"
      >
        {{ item.category }}
        <i class="tablist_line" :style="setColor" v-if="index === activeIndex"></i>
      </li>
      
    </ul>
    <!-- <div class="active-track">
      <div class="active-flag"></div>
    </div> -->
  </div>
</template>

<style lang="less">
.loginTabs {
  .tablist {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    width: 345px;
    margin:auto;
    border-bottom: 1px solid rgba(231,231,231,1);
    margin-bottom: 20px;
    margin-top: 22px;
    li {
      padding-bottom: 14px;
      // border-bottom: 2px solid transparent;
      box-sizing: content-box;
      width:112px;
      height:22px;
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(102,102,102,1);
      line-height:22px;
      position: relative;
      .tablist_line{
        position: absolute;
        bottom:0;
        left:50%;
        transform: translate(-50%,0);
        width:96px ;
        height: 3px;
      }
    }
    li+li{
      margin-left: 32px;
    }
    .active {
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:22px;
      border: none;
      // &::after {
      //   content: '';
      //   display: block;
      //   position: absolute;
      //   width:96px;
      //   height:3px;
      //   background:rgba(104,149,60,1);
      //   border-radius:100px 100px 2px 2px;
      //   margin:auto;
      //   left: 0;
      //   right: 0;
      //   bottom: 0;
      // }
    }
  }
  // .active {
  //   &-track {
  //     width:100px;
  //     border-bottom:1px solid rgba(231,231,231,1);
  //   }
  //   &-flag {

  //   }
  // }
}
</style>

<script>

export default {
  name: 'LoginTabs',
  props: {
    data: Array,
    activeIndex: {
      type: Number,
      default: 0,
    },
    color:{
      type:String,
      default:''
    }
  },
  computed: {
    setColor(){
      return{
        'backgroundColor':this.color
      }
    }
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    slideTo(num) {
      this.$emit('update:activeIndex', num);
    },
  },
};
</script>
